// 应该暂时没有使用
import {
  useFilterSidebar 
} from "@/hooks/FilterSidebar"
import {
  useCallback, useMemo, useRef 
} from "react"
import {
  FormattedMessage 
} from "react-intl"

import {
  useStyle 
} from "@/classify"
import CurrentFilters from "../FilterModal/CurrentFilters"
import FilterBlock from "../FilterModal/filterBlock"
import LinkButton from "../LinkButton"
import defaultClasses from "./filterSidebar.module.css"

const SCROLL_OFFSET = 150

/**
 * A view that displays applicable and applied filters.
 *
 * @param {Object} props.filters - filters to display
 */
const FilterSidebar = (props) => {
  const {
    filters,
    filterCountToOpen = 3,
    aggregations,
    categories,
    sortFields,
  } = props
  const talonProps = useFilterSidebar({
    filters,
    aggregations,
    categories,
    sortFields,
  })
  const {
    filterApi,
    filterItems,
    filterNames,
    filterFrontendInput,
    filterState,
    handleApply,
    handleReset,
  } = talonProps

  const filterRef = useRef()
  const classes = useStyle(defaultClasses, props.classes)

  const handleApplyFilter = useCallback(
    (...args) => {
      const filterElement = filterRef.current

      if (
        filterElement &&
                typeof filterElement.getBoundingClientRect === "function"
      ) {
        const filterTop = filterElement.getBoundingClientRect().top
        const windowScrollY = window.scrollY + filterTop - SCROLL_OFFSET

        window.scrollTo(0, windowScrollY)
      }

      handleApply(...args)
    },
    [handleApply, filterRef]
  )

  const filtersList = useMemo(
    () => Array.from(filterItems, ([group, items], iteration) => {
      const blockState = filterState.get(group)
      const groupName = filterNames.get(group)
      const frontendInput = filterFrontendInput.get(group)

      return (
        <FilterBlock
          key={group}
          filterApi={filterApi}
          filterState={blockState}
          filterFrontendInput={frontendInput}
          group={group}
          items={items}
          name={groupName}
          onApply={handleApplyFilter}
          initialOpen={iteration < filterCountToOpen}
        />
      )
    }),
    [
      filterApi,
      filterItems,
      filterNames,
      filterFrontendInput,
      filterState,
      filterCountToOpen,
      handleApplyFilter,
    ]
  )

  const clearAll = filterState.size ? (
    <div className={classes.action}>
      <LinkButton type='button' onClick={handleReset}>
        <FormattedMessage
          id={"filterModal.action"}
          defaultMessage={"Clear all"}
        />
      </LinkButton>
    </div>
  ) : null

  return (
    <aside
      className={classes.root}
      ref={filterRef}
      aria-live='polite'
      aria-busy='false'
    >
      <div className={classes.body}>
        <div className={classes.header}>
          <h2 className={classes.headerTitle}>
            <FormattedMessage
              id={"filterModal.headerTitle"}
              defaultMessage={"Filters"}
            />
          </h2>
        </div>
        <CurrentFilters
          filterApi={filterApi}
          filterNames={filterNames}
          filterState={filterState}
          onRemove={handleApplyFilter}
        />
        {clearAll}
        <ul className={classes.blocks}>{filtersList}</ul>
      </div>
    </aside>
  )
}

export default FilterSidebar
